import React from 'react';
import { roundigFormat } from '../libs/utils/Operations';
import { SYMBOL } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox, openDocumentDetails, Change_ListName, refs) => {
    let body = "";

    body = data && data.length > 0 && data.map((register, index) => {
        switch (Number(register.RoundSys || 0)) {
            case 1: register.RoundSysName = 'Redondear a importe en decimales entero'; break;
            case 2: register.RoundSysName = 'Redondear a importe entero'; break;
            case 3: register.RoundSysName = 'Redondear a decenas enteras'; break;
            case 4: register.RoundSysName = 'Final fijo'; break;
            case 5: register.RoundSysName = 'Intervalo fijo'; break;
            default: register.RoundSysName = 'Sin redondeo'; break;
        }

        switch (register.RoundRule || "") {
            case 'C': register.RoundRuleName = 'Redondear por exceso'; break;
            case 'F': register.RoundRuleName = 'Redondear por defecto'; break;
            default: register.RoundRuleName = 'Redondear al más cercano'; break;
        }

        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                {headers[0].value && <td> {register.ListName || ""} </td>}
                {headers[1].value && <td> {register.variable || 'No'} </td>}
                {headers[2].value && <td> {register.BasePriceList || ""} </td>}
                {headers[3].value && <td> {parseFloat(register.Factor || 0).toFixed(4)} </td>}
                {headers[4].value && <td> {register.RoundRuleName || ""} </td>}
                {headers[5].value && <td> {`Grupo ${register.GroupCode}`} </td>}
                {headers[6].value && <td> {register.ValidFor === 'Y' ? 'Activo' : 'Inactivo'} </td>}
                {headers[7].value && <td> {register.Currency || ""} </td>}

                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }} >
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => openDocumentDetails({ ListNum: register.ListNum, index })} style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>

        )
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails, Change_ListName, refs) => {
    let header = "";
    let body = "";

    if (headers && headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>
        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDocumentDetails, Change_ListName, refs);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderPriceLists = (headers, data, checkbox, openDocumentDetails, Change_ListName, refs) => {

    return renderTable(headers, data, checkbox, openDocumentDetails, Change_ListName, refs);

}